import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import PlansListBase from "./PlansListBase";
import { API_URL } from "../../consts";

const PAYPAL_MODE = process.env.REACT_APP_PAYPAL_MODE || "production";

const PlansComponent = () => {
  const user = useSelector((state) => state.user);
  const [plans, setPlans] = useState([]);
  const [plansLoading, setPlansLoading] = useState(true);
  const [plansError, setPlansError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchPlans = async () => {
      try {
        setPlansLoading(true);
        setPlansError(null);
        const res = await axios.get(`${API_URL}/plans`, { withCredentials: true });
        if (!cancelled && res.data?.plans) {
          setPlans(res.data.plans);
        }
      } catch (err) {
        if (!cancelled) {
          setPlansError(err.response?.data?.error || err.message || "Failed to load plans");
          setPlans([]);
        }
      } finally {
        if (!cancelled) setPlansLoading(false);
      }
    };
    fetchPlans();
    return () => {
      cancelled = true;
    };
  }, []);

  const showCancelSubscription =
    Boolean(user?.plan_name) &&
    user?.plan_name !== "Free" &&
    user?.subscription_status === "active" &&
    !user?.current_subscription_by_coupon;

  return (
    <PlansListBase
      plans={plans}
      plansLoading={plansLoading}
      plansError={plansError}
      currentPlanName={user?.plan_name ?? ""}
      planType="consumer"
      showRedeemCoupon
      showCancelSubscription={showCancelSubscription}
      user={user}
      showSandboxBanner={PAYPAL_MODE === "sandbox"}
      title="Choose Your Plan"
      subtitle="Select the plan that best fits your needs and budget"
      showDisclaimer
      popularPlanName="Basic"
      wrapperClassName="plans-component"
    />
  );
};

export default PlansComponent;
